import React from 'react'
import { Modal } from '../../../components/elements'
import ShareButton from './../share/bikeShareButton.js'
import FavoritesButton from './../addToFavorites/favoritesButton.js'
import Grid from '@mui/material/Grid'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'
import './profileImageGridModal.css'

const ProfileImageGridModal = (props) => {
  const renderRightNav = (onClick, disabled) => {
    return <RightNav onClick={onClick} disabled={disabled} />
  }
  const renderLeftNav = (onClick, disabled) => {
    return <LeftNav onClick={onClick} disabled={disabled} />
  }
  const { images_length, bikeData, isProfileImage, profileImage } = props
  let profileImages = []
  if (isProfileImage) {
    bikeData.bike_images.map((bikeImage, index) => {
      if (
        !bikeImage.bike_image_cloudinary_public_id == null ||
        !bikeImage.bike_image_cloudinary_public_id == '' ||
        !bikeImage.bike_image_cloudinary_public_id == undefined
      ) {
        profileImages.push({
          original: bikeImage?.bike_image_url,
          thumbnail: bikeImage?.bike_image_url,
        })
      }
    })
  } else {
    profileImages.push({
      original: profileImage?.bike_image_url,
      thumbnail: profileImage?.bike_image_url,
    })
  }
  return (
    <>
      <Grid container item lg={4} md={8} sm={10} xs={6}>
        <Grid item xs={3} className="custom-fav-grid-fav">
          <FavoritesButton
            url={'https://www.twistedroad.com' + bikeData.bike_url}
            quote={
              bikeData.bike_year.toString() +
              ' ' +
              bikeData.bike_make +
              ' ' +
              bikeData.bike_model +
              ' Motorcycle Rental in ' +
              bikeData.bike_location.location_city +
              ', ' +
              bikeData.bike_location.location_region_abbr
            }
            bikeID={bikeData.bike_uuid_id}
            bikeAddedToWishlist={bikeData.in_wishlist}
            bikePrettyID={props.bikePrettyID}
            buttonText={'Save'}
            isMobile={props.isMobile}
          />
        </Grid>
        <Grid item xs={4} className="custom-fav-grid-share">
          <ShareButton
            url={'https://www.twistedroad.com' + bikeData.bike_url}
            quote={
              bikeData.bike_year.toString() +
              ' ' +
              bikeData.bike_make +
              ' ' +
              bikeData.bike_model +
              ' Motorcycle Rental in ' +
              bikeData.bike_location.location_city +
              ', ' +
              bikeData.bike_location.location_region_abbr
            }
            bikePrettyID={props.bikePrettyID}
            buttonText={'Share'}
          />
        </Grid>
        {/* <Grid item xs={12}>
          <Button
            className="see-more-gallery-btn"
            onClick={() => {
              document.body.classList.add('bike-profile-modal-open')
              setShowGridModal(true)
            }}
          >
            <i className="fa fa-th" aria-hidden="true"></i>{' '}
            {'See All ' + images_length + ' Photos'}
          </Button>
        </Grid> */}
      </Grid>
      {props.showGridModal === true && (
        <div className="grid-gallery-modal-wrapper">
          <Modal
            className="my-modal-name"
            images={!props.isMobile}
            showClose={true}
            closeOnEsc={true}
            closeOnBlur={true}
            onClose={() => {
              document.body.classList.remove('bike-profile-modal-open')
              props.toggleModal()
            }}
            show={props.showGridModal}
            size="fullscreen"
          >
            <ImageGallery
              items={profileImages}
              renderRightNav={renderRightNav}
              renderLeftNav={renderLeftNav}
            />
          </Modal>
        </div>
      )}
    </>
  )
}

const RightNav = (props) => {
  const settings = {
    width: props.isMobile ? '2rem' : '5.75rem',
    height: props.isMobile ? '2rem' : '3rem',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: props.isMobile ? '15px' : '38px',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  }
  const { onClick } = props
  return (
    <button
      className="bikegallery-nextarrow-wrapper image-gallery-icon image-gallery-right-nav"
      onClick={onClick}
    >
      <div classname="next-arrow">
        <i className="fas fa-angle-right" style={settings}></i>
      </div>
    </button>
  )
}

const LeftNav = (props) => {
  const settings = {
    width: props.isMobile ? '2rem' : '5.75rem',
    height: props.isMobile ? '2rem' : '3rem',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: props.isMobile ? '15px' : '38px',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  }
  const { onClick } = props
  return (
    <button
      className="bikegallery-leftarrow-wrapper image-gallery-icon image-gallery-left-nav"
      onClick={onClick}
    >
      <div classname="next-arrow">
        <i className="fas fa-angle-left" style={settings}></i>
      </div>
    </button>
  )
}

export default ProfileImageGridModal

ProfileImageGridModal.defaultProps = {
  showGridModal: false,
}
